import Phaser from "phaser"
// @ts-ignore

export default class GameOverScene extends Phaser.Scene {

    constructor() {
        super('game-over-scene')
    }

    init(data){
        this.score = data.score
        this.replayButton = undefined
    }

    preload() {
        this.load.image('bg-gameover', 'images/bg_gameover.png')
        this.load.image('game-over-text', 'images/gameover.png')
        this.load.image('replay-button', 'images/replay.png')
    }

    create(){
        this.add.image(240, 250, 'bg-gameover')
        this.add.image(240, 250, 'game-over-text')

        this.add.text(150, 125, 'Score:  ', {
			fontSize: '33px',
			color: '#FFD700',
		});
		this.add.text(270, 125, this.score, {
			fontSize: '33px',
			color: '#FFD700',
		});


        this.replayButton = this.add.image(240, 370, 'replay-button').setInteractive().setScale(0.6)

        // ketika di klik, scene akan berpindah ke CoronaBusterScene
        this.replayButton.once('pointerup', () => {
            this.scene.start('math-fighter-scene')
        }, this)


    }
}